import type { HorizontalNavItems, VerticalNavItems } from '@layouts/types';

type NavItem = VerticalNavItems[number] | HorizontalNavItems[number];

function isElementCatalogLink(item: NavItem): boolean {
  if (!('to' in item) || !item.to || typeof item.to !== 'object') return false;
  return 'name' in item.to && item.to.name === 'element-catalog';
}

function filterNavItem(item: NavItem, isSuperAdmin: boolean): NavItem | null {
  if ('children' in item && Array.isArray(item.children)) {
    const children = item.children
      .map((child) => filterNavItem(child as NavItem, isSuperAdmin))
      .filter((child): child is NavItem => child !== null);
    if (children.length === 0) return null;
    return { ...item, children } as NavItem;
  }
  if (!isSuperAdmin && isElementCatalogLink(item)) return null;
  return item;
}

export function filterNavForSuperAdmin<T extends VerticalNavItems | HorizontalNavItems>(
  items: T,
  isSuperAdmin: boolean,
): T {
  if (isSuperAdmin) return items;
  return items
    .map((item) => filterNavItem(item, isSuperAdmin))
    .filter((item): item is NavItem => item !== null) as T;
}
